import { useOltPartnerHooks } from "../../utils/project/PartnerUtils";

const OltPartnerDropdown = ({ value, onChange }) => {
  const { oltPartners } = useOltPartnerHooks();

  return (
    <select className="form-control" value={value} onChange={onChange}>
      <option value="">SEMUA</option>
      {oltPartners.map((olt, index) => (
        <option value={olt.name} key={index}>
          {olt.name}
        </option>
      ))}
    </select>
  );
};

export default OltPartnerDropdown;
